<div class="login">
    <div class="lang-select">
        <!-- <mat-form-field>
            <mat-select value="">
                <mat-option value="en">EN</mat-option>
                <mat-option value="ar">عربی</mat-option>
            </mat-select>
        </mat-form-field> -->
        <mat-form-field>
            <mat-select [(value)]="selectedLang" (selectionChange)="lan($event.value)">
                <mat-option value="en">EN</mat-option>
                <mat-option value="ar">عربی</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div class="main-wrap">
        <div class="comp-wrap">
            <div class="logo">
                <img src="assets/images/logo-full.svg" alt="abu dhabi customs logo">
            </div>
            <div class="login-form">
                <mat-card>
                    <mat-card-content>
                        <div class="avatar">
                            <img src="assets/images/User.svg" alt="avatar">
                        </div>
                        <h2 class="heading">{{"Login"|translate}}</h2>
                        <p class="sub-heading">{{'Welcome back, please login to your account'|translate}}</p>
                        <form>
                            <div class="ro">
                                <div class="d-flex justify-content-center">
                                    <button mat-flat-button color="primary" (click)="signIn()"
                                        class="g-primary-btn">{{'Login'|translate}}</button>
                                </div>
                            </div>
                        </form>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="login-bottom">
                <p class="login-footer-text">{{'© 2024 Abu Dhabi Customs. All rights reserved.'|translate}}</p>
            </div>
        </div>
    </div>
    <img src="/assets/images/logo-symbol.svg" class="top-logo-bg" alt="">
    <img src="/assets/images/logo-symbol.svg" class="bottom-logo-bg" alt="">
</div>